module.exports = __webpack_public_path__ + "img/dollar.b024d212.svg";